// src/themes/diurno.js
//
// Tema Día (HUD claro) — tema claro con accent guinda institucional.
// Guinda #9f2241 (color oficial del gobierno mexicano) sobre fondos blancos
// / gris azulado claro. Pensado para salas con luz ambiental alta,
// proyección, o pantallas con brillo reducido. Único tema claro del catálogo.
//
// Anclas fijas (stakeholder): bgDeep #E9EEF3, bgSurface #FFFFFF,
// bgCard #F4F7FA, text #142231, textMuted #506276. El accent se cambió de
// cyan a guinda #9f2241 (sesión 2026-06-01). Todo verificado contra WCAG AA.
//
// flag `isLight: true` — lo consume el código (NO mapBasemap, que sigue en
// NON_TOKEN_KEYS de apply.js). Activa el basemap diurno 'light' de MapTiler
// y el botón "Día" del selector de basemap en MapToolbar. Ver apply.js
// (NON_TOKEN_KEYS), map-constants.js (getStyleUrl) y MapV2.vue (created()).
//
// SISTEMA B — override COMPLETO requerido. Los tokens entity*/status*/
// alert*/kpi* de system-b.js están calibrados para fondo oscuro (L 55-76)
// y sobre blanco fallan AA 4.5:1. Este tema los oscurece ~15-25 puntos de L
// manteniendo el hue semántico (verde online, rojo offline, ámbar alert,
// rojo SOS el más saturado). Se declaran abajo y apply.js los mergea
// con { ...systemB, ...theme } (el tema gana). statusOffline/statusIdle/
// alertDanger NO se overridean: ya pasan AA en claro tal cual.
//
// Inversión de elevación: en temas oscuros los paneles son MÁS CLAROS que
// el fondo; en claro son MÁS BLANCOS (bgSurface #FFFFFF) que el fondo de
// página (bgDeep #E9EEF3). bgCard #F4F7FA queda en medio.
//
// Bordes en rgba(0,0,0,alpha) (negro tenue), NO rgba(255,255,255,...) como
// los temas dark. Shadows: los glow neón no aplican en claro; accent/alert
// BoxShadow usan drop-shadows sutiles, y los TextShadow son 'none' (sobre
// fondo claro producen halos sucios, no glow limpio). trailLine #9f2241:
// guinda profundo, visible sobre cartografía clara y diferenciable del
// agua del mapa.

export default {
  id: 'diurno',
  label: 'Día (HUD claro)',
  mapBasemap: 'light',  // informativo; el código usa isLight para la lógica
  isLight: true,        // FLAG funcional: basemap claro + botón Día en toolbar

  // ========== SISTEMA A — CHROME ==========

  // Identidad — guinda institucional #9f2241 (color oficial del gobierno
  // mexicano). 7.56:1 sobre blanco. accentBright #BD2C50 es un guinda más
  // vivo/claro para hover (5.77:1, claramente distinguible del base).
  accent:       '#9f2241',
  accentSoft:   'rgba(159, 34, 65, 0.14)',
  accentGlow:   'rgba(159, 34, 65, 0.28)',
  accentBright: '#BD2C50',

  // Fondos — claros, 3 niveles (página < card < panel)
  bgDeep:    '#E9EEF3',
  bgSurface: '#FFFFFF',
  bgCard:    '#F4F7FA',
  bgOverlay: 'rgba(233, 238, 243, 0.96)',

  // Texto — navy oscuro sobre claro, 3 niveles. Todos pasan AA-normal
  // (>=4.5) sobre los tres fondos.
  text:      '#142231',
  textMuted: '#506276',
  textDim:   '#55697F',
  // Override del token compartido de system-b (#8FA3C2, pensado para dark):
  // en claro necesita un navy oscuro. 6.14:1 sobre #FFFFFF, 5.71:1 sobre card.
  textLabel: '#51637B',

  // Bordes — negro tenue (inversión respecto de los temas dark)
  borderDim:    'rgba(0, 0, 0, 0.07)',
  borderNormal: 'rgba(0, 0, 0, 0.12)',
  borderAccent: 'rgba(159, 34, 65, 0.40)',

  // Trail GPS — guinda profundo, visible sobre mapa claro (7.56:1)
  trailLine: '#9f2241',

  // Murphy themed — rampa guinda. Solo se aplica si el modo Murphy es
  // 'themed'. En 'neutral' (default) ganan los grises de MURPHY_NEUTRAL.
  murphyLight: '#E6B3C0',
  murphyMid:   '#9f2241',
  murphyDeep2: '#7A1A33',
  murphyDeep1: '#5A1326',
  murphyInk:   '#2E0A15',

  // ========== SISTEMA B — override de operativos y status ==========
  // Sobrescriben los defaults de system-b.js: oscurecidos para conservar
  // contraste AA sobre fondo claro, manteniendo el hue semántico. Hue gaps
  // de los 7 entity* verificados >=30°.

  entityBlue:   '#2248A0',
  entityTeal:   '#1E7A91',
  entityGreen:  '#1E6E48',
  entityGold:   '#667406',
  entityOrange: '#84540B',
  entityRed:    '#A0291C',
  entityViolet: '#6B3DAB',

  statusOnline: '#2E6152',
  statusAlert:  '#8A5A0A',

  alertSos:     '#BE2013',            // el más saturado del conjunto (urgencia)
  alertWarning: '#7A5A08',
  alertSuccess: '#1A7040',
  alertInfo:    '#1A5A9A',
  alertSosSoft: 'rgba(190, 32, 19, 0.14)',

  kpiSeguridad: '#2248A0',            // = entityBlue (misma semántica)
  kpiMedico:    '#A81C4E',
  kpiPcivil:    '#7A5A08',
  kpiPublico:   '#0E6E70',

  // ========== TOKENS EXTENDIDOS ==========
  fontFamily:         "'Public Sans', -apple-system, BlinkMacSystemFont, sans-serif",
  labelTransform:     'none',
  labelLetterSpacing: 'normal',
  accentTextShadow:   'none',
  alertTextShadow:    'none',
  accentBoxShadow:    '0 2px 8px rgba(159, 34, 65, 0.18)',
  alertBoxShadow:     '0 2px 8px rgba(190, 32, 19, 0.18)',
  routeActiveWidth:   4,
  routePreviewWidth:  2.5,
  clusterMode:        'colorful',

  // ========== Categorías 911 (manual oficial federal CNIE v3.0) ==========
  // Versión para fondo claro: oscurecidas para pasar AA como chip/texto
  // sobre blanco, conservando la familia cromática del manual federal.
  catSeguridad:         '#1B4A9B',  // azul profundo
  catMedico:            '#176B32',  // verde profundo
  catProteccionCivil:   '#7A5C00',  // amarillo-oliva profundo (separado de asistencia)
  catServiciosPublicos: '#4B2A96',  // morado profundo
  catAsistencia:        '#8C3D00',  // naranja-rojizo profundo (separado de PC)
  catOtrosServicios:    '#4B5563',  // gris oscuro
  catMalUso:            '#8B1A1A',  // rojo profundo
}
